import { render, staticRenderFns } from "./WenZhangDiscoverDetail.vue?vue&type=template&id=1a1c1bee&scoped=true"
import script from "./WenZhangDiscoverDetail.vue?vue&type=script&lang=js"
export * from "./WenZhangDiscoverDetail.vue?vue&type=script&lang=js"
import style0 from "@wangeditor/editor/dist/css/style.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./WenZhangDiscoverDetail.vue?vue&type=style&index=1&id=1a1c1bee&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1c1bee",
  null
  
)

export default component.exports